import React from 'react'

function CompanyRequest() {
    return (
        <div>CompanyRequest</div>
    )
}

export default CompanyRequest